import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getProgressEntryPct, formatProgressCounts } from './helpers/progress';

// The full tick history inside a ToolCallCard's expanded body — expert-only
// depth, consistent with payloads staying hidden until the card opens. Stage
// changes get an eyebrow divider.
const ToolCallProgressTimeline = ({ updates }) => (
  <ol className='ap-tool-call-timeline'>
    {updates.map((update, i) => {
      const prevStage = i > 0 ? updates[i - 1].stage : null;
      const pct = getProgressEntryPct(update);
      const countsText = formatProgressCounts(update.counts);
      return (
        <li key={update.seq}>
          {update.stage && update.stage !== prevStage && (
            <div className='ap-tool-call-timeline-stage'>{humanizeStage(update.stage)}</div>
          )}
          <div className='ap-tool-call-timeline-row'>
            <span className='ap-tool-call-timeline-time'>{moment(update.at).format('HH:mm:ss')}</span>
            <span className='ap-tool-call-timeline-label'>
              {update.progressLabel || '—'}
              {countsText ? ` · ${countsText}` : ''}
            </span>
            <span className='ap-tool-call-timeline-pct'>{pct != null ? `${Math.round(pct)}%` : ''}</span>
          </div>
          {update.detail && <div className='ap-tool-call-timeline-detail'>{update.detail}</div>}
        </li>
      );
    })}
  </ol>
);

// `stage` is a machine-readable id ("scoring", "fee_curves") — soften it for display.
const humanizeStage = stage => String(stage).replace(/[-_]+/g, ' ').replace(/^\w/, c => c.toUpperCase());

ToolCallProgressTimeline.propTypes = {
  updates: PropTypes.array.isRequired
};

export default ToolCallProgressTimeline;
